import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { themePalette } from '@theme/muiTheme';

export const UnderlineTextButton = styled(Typography, {
  shouldForwardProp: (prop) => prop !== '$disabled',
})<{
  $disabled: boolean;
}>`
  text-decoration: underline;
  color: ${({ $disabled }) => themePalette.grey[$disabled ? 700 : 1000]};
  cursor: ${({ $disabled }) => ($disabled ? 'default' : 'pointer')};

  &:hover {
    color: ${({ $disabled }) => themePalette.grey[$disabled ? 700 : 900]};
  }
`;

UnderlineTextButton.defaultProps = {
  variant: 'body1',
};
